<template>
  <Breadcrumbs
      title="Dealer Groups"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealer Groups', path: '/dealer-groups' },
      { label: 'View Dealer Group', path: `/view-dealer-group?dealerGroupId=${dealerGroupId}` },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <viewDealerGroupForm :dealerGroupId="dealerGroupId" />
    </div>
  </div>
</template>

<script>

import viewDealerGroupForm from "@/pages/master_data/dealer_groups/viewDealerGroupForm.vue";

export default {
  components: {
    viewDealerGroupForm
  },
  computed: {
    dealerGroupId() {
      return this.$route.query.dealerGroupId;
    }
  }
}
</script>